const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('block/tabs-company-item', {
  title: 'Item - Tab para sua empresa',
  description: 'Esta é uma aba do componente tabs',
  icon: 'editor-table',
  category: 'design',
  attributes,
  parent: ['block/tabs-company'],

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
